﻿import ko from 'knockout';
import $ from 'jquery';
import { IBinder, IBehaviorBinding, ICellBinding } from "./ibinder"

export class CheckboxInputBinder implements IBinder {
  public getElements(row: JQuery): JQuery {
    return row.find(":input[type='checkbox']");
  }

  public getBinding(cell: JQuery): ICellBinding {
    var bindingName = "init, checked";
    var cellName = cell.attr("name");

    return {
      dataName: cellName,
      dataValue: ko.observable(cell.is(":checked")),
      bindingName: bindingName,
      bindTo: cellName,
      createEmptyValue: () => ko.observable()
    }
  }
}
